import React from 'react';
import { InputErrorComponent } from '../components/input-error.component'

export function InputErrorContainer ({ error }: any) {
  return <InputErrorComponent error={error} />
}
